import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiUrlService {

  private baseUrl: string;

  constructor() {
    this.baseUrl = this.detectBaseUrl();
  }

  getApiUrl(): string {
    return `${this.baseUrl}`;
  }

  private detectBaseUrl(): string {
    if ('__appBaseUrl' in window && typeof window.__appBaseUrl === 'string') {
      return window.__appBaseUrl;
    }
    return '';
  }
}
